<template>
  <header class="app-header">
    <div class="container header-container">
      <div class="logo">
        <img src="@/assets/zhixin.png" alt="河北致鑫环境科技有限公司" class="logo-img" />
        <span class="logo-text">河北致鑫环境科技</span>
      </div>
      <nav class="nav-desktop">
        <a href="#home" class="nav-link">首页</a>
        <a href="#about" class="nav-link">关于我们</a>
        <a href="#services" class="nav-link">服务项目</a>
        <a href="#advantages" class="nav-link">核心优势</a>
        <a href="#contact" class="nav-link">联系我们</a>
      </nav>
      <button class="menu-toggle" @click="toggleMenu" aria-label="切换菜单">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </button>
      <nav class="nav-mobile" :class="{ 'show': menuOpen }">
        <a href="#home" class="nav-link" @click="closeMenu">首页</a>
        <a href="#about" class="nav-link" @click="closeMenu">关于我们</a>
        <a href="#services" class="nav-link" @click="closeMenu">服务项目</a>
        <a href="#advantages" class="nav-link" @click="closeMenu">核心优势</a>
        <a href="#contact" class="nav-link" @click="closeMenu">联系我们</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      menuOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
    }
  }
};
</script>

<style scoped>
.app-header {
  background-color: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-img {
  height: 40px;
  width: auto;
  border-radius: 4px;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1E5AA8;
  white-space: nowrap;
}

.nav-desktop {
  display: flex;
  gap: 2rem;
}

.nav-link {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  transition: color 0.3s;
  position: relative;
  padding: 0.5rem 0;
}

.nav-link:hover {
  color: #1E5AA8;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #1E5AA8;
  transition: width 0.3s;
}

.nav-link:hover::after {
  width: 100%;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

.bar {
  width: 100%;
  height: 3px;
  background-color: #333;
  border-radius: 2px;
  transition: 0.3s;
}

.nav-mobile {
  display: none;
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  gap: 1rem;
  transform: translateY(-10px);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.nav-mobile.show {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

.nav-mobile .nav-link {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #eee;
}

@media (max-width: 768px) {
  .nav-desktop {
    display: none;
  }
  .menu-toggle {
    display: flex;
  }
  .nav-mobile {
    display: flex;
  }
}
</style>
